import React, { useEffect, useRef, useState } from "react";
import { Container } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { logo } from "../Data/Images/Home";
import CustomLink from "../Components/CustomLink";
import { useConsumeMagicLoginMutation } from "../features/auth/authApiSlice";
import { setCredentials } from "../features/auth/authSlice";
import { persistCustomerAuth } from "../utils/customerAuth";

import "../assets/scss/pages/_login.css";

const MagicLoginCallback = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasConsumedToken = useRef(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [consumeMagicLogin, { isLoading }] = useConsumeMagicLoginMutation();

  useEffect(() => {
    if (hasConsumedToken.current) return;
    hasConsumedToken.current = true;

    const token = searchParams.get("token");
    if (!token) {
      setErrorMessage(t("Auth_MagicLogin_Invalid"));
      return;
    }

    const handleConsumeToken = async () => {
      try {
        const userData = await consumeMagicLogin({ token }).unwrap();
        dispatch(setCredentials({ ...userData, storage: true }));
        persistCustomerAuth(userData);
        toast.success(t("Auth_LoginSuccess"));
        navigate("/dashboard", { replace: true });
      } catch (err) {
        setErrorMessage(err?.data?.message || t("Auth_MagicLogin_Invalid"));
      }
    };

    handleConsumeToken();
  }, [consumeMagicLogin, dispatch, navigate, searchParams, t]);

  return (
    <>
      <Container
        fluid={true}
        className="login-section section-padding pt-0"
        style={{
          backgroundImage: `linear-gradient(var(--secondary-80),var(--secondary-80))`,
        }}
      >
        <div className="container d-flex t-flex-col align-items-center justify-content-center vh-100 t-gap-20 md:-t-mt-10">
          <div className="mlogo t-mb-4">
            <CustomLink to="/">
              <img src={logo} alt="" width={120} />
            </CustomLink>
          </div>
          <div className="t-w-full t-max-w-[400px] t-mx-auto t-bg-gray-50 t-flex t-flex-col t-gap-8 t-shadow-lg t-rounded-md !t-py-12 t-px-4">
            <div className="t-text-2xl t-font-bold t-text-center t-text-tertiary">
              {errorMessage ? t("Auth_MagicLogin_ErrorTitle") : t("Auth_MagicLogin_CallbackTitle")}
            </div>
            <p className="!t-m-0 !t-text-base t-text-center t-text-gray-600">
              {errorMessage || (isLoading ? t("Auth_MagicLogin_SigningIn") : t("Auth_MagicLogin_SigningIn"))}
            </p>
            {errorMessage && (
              <div className="t-flex t-items-center t-justify-center t-gap-4 t-flex-wrap">
                <CustomLink to="/magic-login" className="t-text-tertiary">
                  <p className="t-text-tertiary !t-m-0">{t("Auth_MagicLogin_RequestAgain")}</p>
                </CustomLink>
                <CustomLink to="/login" className="t-text-tertiary">
                  <p className="t-text-tertiary !t-m-0">{t("Auth_BackToLogin")}</p>
                </CustomLink>
              </div>
            )}
          </div>
        </div>
      </Container>
      <ToastContainer />
    </>
  );
};

export default MagicLoginCallback;
